<template>
  <div>
    <Table
      resource="TransactionV2"
      :actions="actions"
      :items="$store.getters['transactionV2/tableData']"
      :detail="$store.getters['transactionV2/detailData']"
      :detail-route="row => `/transactions/${row.id}/detail`"
      :fields="$store.getters['transactionV2/tableFields']"
      :pagination="$store.state.transactionV2.tablePagination"
      :keyword="$store.state.transactionV2.tableKeyword"
      :loading="$store.state.transactionV2.loadingTable"
      :filter="$store.state.transactionV2.tableFilter"
      :sort="$store.state.transactionV2.tableSort"
      :sort-options="sortOptions"
      :tab-options="tabOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    >
      <!-- Custom cell: invoice_number with date below -->
      <template #cell-invoice_number="{ data }">
        <div class="mb-25 d-flex align-items-center flex-nowrap">
          <a
            :href="`/transactions/${data.item.id}/detail`"
            target="_blank"
            class="font-weight-bold"
          >
            {{ data.item.invoice_number ? data.item.invoice_number : '-' }}
          </a>
          <feather-icon
            v-b-tooltip.hover.top="'Salin No Invoice'"
            icon="CopyIcon"
            size="16"
            class="copy-btn ml-25"
            @click.stop="onCopy(data.item.invoice_number, 'No Invoice')"
          />
        </div>
        <small>
          {{ data.item.accepted_at ? formatDate(data.item.accepted_at) : formatDate(data.item.created_at) }}
          {{ data.item.accepted_at ? formatTime(data.item.accepted_at) : formatTime(data.item.created_at) }}
        </small>
      </template>
    </Table>
  </div>
</template>

<script>
import Table from '@/layouts/components/v2/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'view',
      ],

      // Tabs
      tabOptions: [
        { key: 'statuses', label: 'Semua' },
        // Transaction statuses (aligned with enums)
        { key: 'statuses', label: 'Dibuat', value: 'created' },
        { key: 'statuses', label: 'Dikonfirmasi', value: 'confirmed' },
        {
          key: 'statuses',
          label: 'Diterima',
          value: 'accepted',
          default: true,
        },
        { key: 'statuses', label: 'Request Pickup', value: 'pickup_requested' },
        { key: 'statuses', label: 'Dikirim', value: 'pickedup' },
        { key: 'statuses', label: 'Terkirim', value: 'delivered' },
        { key: 'statuses', label: 'Dibatalkan', value: 'cancelled' },
        { key: 'statuses', label: 'Ditolak', value: 'rejected' },
        { key: 'statuses', label: 'Refund Pending', value: 'refund_pending' },
        { key: 'statuses', label: 'Refunded', value: 'refunded' },
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('transactionV2/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('transactionV2/getDetail', id)
    },
    deleteData(id, callback) {
      // not used in v2 transactions for now
      if (typeof callback === 'function') callback()
      return Promise.resolve()
    },
    resetDetail() {
      this.$store.commit('transactionV2/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('transactionV2/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('transactionV2/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('transactionV2/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('transactionV2/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('transactionV2/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('transactionV2/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
